import { QuestionCircleOutlined } from "@ant-design/icons";
import { Input,InputNumber,Button, Tooltip } from "antd";
import styled from 'styled-components';


const CustomInput = styled(Input)`
    height: 50px !important;
    line-height: 50px !important;
    border-radius:4px !important;
    &:hover{
        border-color: #6ee6c6 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
    }
`

const CustomInputNumber = styled(InputNumber)`
    height: 50px !important;
    line-height: 50px !important;
    border-radius:4px !important;
    &:hover{
        border-color: #6ee6c6 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
    }
`

const CustomInputNumberMyReport = styled(InputNumber)`
    &:hover{
        border-color: #6ee6c6 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
    }
`

const CustomInputPassword = styled(Input.Password)`
    height: 50px !important;
    line-height: 50px !important;
    border-radius:4px !important;
    &:hover{
        border-color: #6ee6c6 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
    }
`

const CustomInputTextarea = styled(Input.TextArea)`
    height: 120px !important;
    line-height: 30px !important;
    border-radius:4px !important;
    &:hover{
        border-color: #6ee6c6 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
    }
`

const SubmitReportButton = styled(Button)`
    font-family:HelveticaNeueBold;
    height: 40px !important;
    //line-height: 40px !important;
    border-radius: 20px !important;
    border-color: #6ee6c6 !important;
    color:#6ee6c6 !important;
    &:hover{
        border-color: #6ee6c6 !important;
        background-color: #6ee6c6 !important;
        color:#000 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
        background-color: #6ee6c6 !important;
        color:#000 !important;
    }
`

const CustomTooltip = styled(Tooltip)`
    
`


const CustomQuestionCircleOutlined = styled(QuestionCircleOutlined)`
    &:hover{
        cursor:pointer;
    }
`


export {CustomInput, CustomInputNumber, CustomInputNumberMyReport, CustomInputPassword, CustomInputTextarea, SubmitReportButton, CustomTooltip, CustomQuestionCircleOutlined};